import { Typography } from 'components/_common/Typography';
import React from 'react';

const RiskOverviewDetailColumnNoDataListItem: React.FC = () => {
  return (
    <li data-testid="no-data-list-item">
      <Typography variant="body2">No data available</Typography>
    </li>
  );
};

export default RiskOverviewDetailColumnNoDataListItem;
